// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mo9Lq2dIalSXXpruanCZ{margin-bottom:var(--spacing-small)}.DIqTOJq1BIWhbbmOi0yt{width:100%;margin-top:var(--spacing-xxxSmall)}`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.module.scss"],"names":[],"mappings":"AAAA,sBAAiB,kCAAkC,CAAC,sBAAW,UAAU,CAAC,kCAAkC","sourcesContent":[".modal-paragraph{margin-bottom:var(--spacing-small)}.modal-img{width:100%;margin-top:var(--spacing-xxxSmall)}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-paragraph": `mo9Lq2dIalSXXpruanCZ`,
	"modal-img": `DIqTOJq1BIWhbbmOi0yt`
};
export default ___CSS_LOADER_EXPORT___;
